import { ChangeQItem, ChangeQItemArgs } from './item';

export const isFileChangeQItem = (object: ChangeQItem): object is FileChangeQItem => {
    return object.entity === 'file';
};

export interface FileChangeQItemArgs extends ChangeQItemArgs {
    fileSize: number;
    localFileSystemPath: string;
    mimeType: string;
    name: string;
    startChunkNumber?: number;
    uploadUrl?: string;
}

const defaults = () => ({
    fileSize: 0,
    localFileSystemPath: '',
    mimeType: '',
    name: '',
    startChunkNumber: 0,
    uploadUrl: undefined
});

export class FileChangeQItem extends ChangeQItem {
    fileSize: number;
    localFileSystemPath: string;
    mimeType: string;
    name: string;
    startChunkNumber: number;
    uploadUrl: string;

    constructor(data?: FileChangeQItemArgs) {
        super(data);

        const fileData = {...defaults(), ...data};
        this.fileSize = fileData.fileSize;
        this.localFileSystemPath = fileData.localFileSystemPath;
        this.mimeType = fileData.mimeType;
        this.name = fileData.name;
        this.startChunkNumber = fileData.startChunkNumber || 0;
        this.uploadUrl = fileData.uploadUrl;
    }

    update(args = {} as any): FileChangeQItem {
        return new FileChangeQItem({
            ...this.toObject(),
            ...args
        });
    }

    toObject(): object {
        return {
            ...super.toObject(),
            fileSize: this.fileSize,
            localFileSystemPath: this.localFileSystemPath,
            mimeType: this.mimeType,
            name: this.name,
            startChunkNumber: this.startChunkNumber,
            uploadUrl: this.uploadUrl
        };
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/file-item.ts